import React from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Card, Icon } from '@node-space/ui-components'
import { formatAmount } from 'pages/Rewards/utils'

export interface RewardsEmbeddedSummaryProps {
  currency: string
  baseCurrency: string
  totalBalance: number
  totalEarnings: number
  hasBeenDisbursed: boolean
}

export const RewardsEmbeddedSummary = ({
  currency,
  baseCurrency,
  totalBalance,
  totalEarnings,
  hasBeenDisbursed,
}: RewardsEmbeddedSummaryProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="static" emphasis full>
      <Box
        flexCol
        gap={24}
        justify="between"
        className={clsx('xl:flex-row', {
          'xl:justify-between xl:items-center': hasBeenDisbursed,
        })}
      >
        <Box gap={8} flexCol>
          <p className="text-body-regular-small text-foreground-prominent">
            {t('rewards.embeddedCustomers.totalAllocatedBalance', { currency })}
          </p>

          <Box flex align="center" gap={8} className="lg:justify-start">
            <Avatar name={baseCurrency} type="currency" />
            <p className="text-h1 text-foreground-prominent">{formatAmount(totalBalance)}</p>
          </Box>

          <Box flex align="center" gap={8} className="lg:justify-start text-foreground-prominent">
            <Icon name="SketchLogo" size="medium" />
            <p className="text-body-strong text-foreground-subdued">
              {t('rewards.allTimeEarnings', {
                currency: baseCurrency,
                amount: formatAmount(totalEarnings),
              })}
            </p>
          </Box>
        </Box>
        {hasBeenDisbursed && (
          <Box flexCol gap={8}>
            <p className="text-body-strong-large text-foreground-prominent">
              {t('rewards.embeddedCustomers.disbursed')}
            </p>
          </Box>
        )}
      </Box>
    </Card>
  )
}
